module.exports = __webpack_public_path__ + "static/banner-efd0a379216c7eee4fdf298d1044eeda.png";